import React, {useEffect, useRef, useState} from 'react';
import {NavLink} from "react-router-dom";
import '../../assets/css/reward.css';
import arrowImg from '../../assets/images/icons/arrow.png';
import warningIcon from '../../assets/images/icons/warning-icon.svg';
import RewardsJsonData from "../data/items.json";
import Slider from 'react-slick';
import Loader from "../includes/Loader";
import {requestGetHTTP, requestPostHTTP} from "../helpers/helper";
import { useSelector } from 'react-redux';
import {isLogin} from "../auth/AuthController";
import rewardsImg from "../../assets/images/icons/rewards.png";


function TournamentPage() {
    const [rewards, setRewards] = useState(null);
    const [rewardsEmail, setRewardsEmail] = useState('');
    const [rewardsItemCoins, setRewardsItemCoins] = useState([]);
    const [rewardsItemName, setRewardsItemName] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingModal, setLoadingModal] = useState(false);
    const [warningMsg, setWarningMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [profile, setProfile] = useState([]);
    const [notProfile, setNotProfile] = useState(false);
    const modal = useSelector((state) => state.openSubscribedModal);
    const showWarningModal = useRef(null);
    const showSuccessModal = useRef(null);
    const showRewardsFormModal = useRef(null);
    const rewardsEmailRef = useRef(null);
    const [isValidEmail, setIsValidEmail] = useState(false);

    useEffect(() => {
        document.title = 'Rewards | Jazz Esl'; // title
        setRewards(Object.values(RewardsJsonData));

        async function fetchProfileData() {
            try {
                let getProfile = await requestGetHTTP('/v1/user/profile');
                if (getProfile) {
                    setProfile(getProfile);
                } else {
                    setNotProfile(true);
                }
            } catch (error) {
                console.error('profile data fetch', error);
            } finally {
                setLoading(false);
            }
        }
        if(isLogin()) {
            fetchProfileData();
        }else{
            setNotProfile(true);
            setLoading(false);
        }
    }, []);

    /**
     * Update Profile
     */
    function rewardsModalForm() {
        setLoadingModal(true);
        if(isValidEmail === false){
            setLoadingModal(false);
            return false;
        }
        try {
            /*requestPostHTTP('/v1/user/profile/complete', {
                email: rewardsEmail,
            });*/

            purchaseRewards('submit', rewardsItemCoins, rewardsItemName);
        } catch (error) {
            console.error('Getting rewards email address giving issue ', error);
        } finally {
            setLoadingModal(false);
        }
    };

    /**
     *
     * @param event
     * @param coinsForPurchaseNeeded
     * @param itemName
     */
    const purchaseRewards = (event, coinsForPurchaseNeeded, itemName) => {
        setLoadingModal(true);
        if(!isLogin()){
            (event !== 'submit') && event.preventDefault();
            modal.subscribedModalRef.current.click();
            setLoadingModal(false);
        }else{
            setRewardsItemCoins(coinsForPurchaseNeeded);
            setRewardsItemName(itemName);

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValid = emailRegex.test(rewardsEmail);

            if((!rewardsEmail || rewardsEmail === '' || isValid === false || event !== 'submit')){
                showRewardsFormModal.current.click();
                setLoadingModal(false);
                return;
            }

            const intCredits = parseInt(coinsForPurchaseNeeded.replace(/\D/g, ''), 10);
            const userCredits = parseInt(profile.credits, 10);
            if(userCredits < intCredits){
                setWarningMsg('You have insufficient coins');
                showWarningModal.current.click();
                setLoadingModal(false);
            }else{
                let claimData = {
                    name: profile.username,
                    phone: profile.phone,
                    email: rewardsEmail,
                    item: itemName,
                    price: coinsForPurchaseNeeded
                }
               requestPostHTTP('/v1/redeem/claim', claimData).then(response => {
                    if(response.data.message === 'ok'){
                        setSuccessMsg('You have successfully purchased the rewards');
                        showSuccessModal.current.click();
                        setRewardsEmail('');
                        setLoadingModal(false);
                    }else{
                        setWarningMsg(response.data.message);
                        showWarningModal.current.click();
                        setLoadingModal(false);
                    }
               }).catch(error => {
                   console.error('Purchase Rewards Error', error);
                   setLoadingModal(false);
               });
            }
        }
    }

    /**
     *
     * @param coinsInLoop
     * @returns {string}
     */
    const rewardsProgressBar = (coinsInLoop) =>{
        let defaultTop = 130;
        if(coinsInLoop >= 500){
            let remainCoins =  profile.credits - coinsInLoop;
            let tempTop = remainCoins * 3.44;
            defaultTop = tempTop + defaultTop;
        }else{
            let tempTop = profile.credits * 2.27;
            defaultTop = tempTop + defaultTop;
            console.log(defaultTop);
        }
        return defaultTop+'%';
    }

    /**
     *
     * @param index
     * @returns {number}
     */
    const getRewardsNum = (index, init) =>{
        if(init === 'init'){
            return 499;
        }
        return ((index + 1) * 500);
    }

    /**
     * Profile Email change
     */
    const handleChangeRewardsEmail = () => {
        if (rewardsEmailRef.current) {
            const rewardsEmail = rewardsEmailRef.current.value;

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValid = emailRegex.test(rewardsEmail);
            setIsValidEmail(isValid);
            setRewardsEmail(rewardsEmail);
        }
    };

    /**
     *
     * @type {number}
     */
    const windowWidth = window.innerWidth;
    let slidesToShow = 3.999;
    if (windowWidth > 850 && windowWidth <= 900) {
        slidesToShow = 2.999;
    } else if (windowWidth <= 850) {
        slidesToShow = 1;
    }

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000,
    };

    return (
        <>
        <div className="rewards-wrapper">
            <div className="rewards-heading">
                <h2 className="headingz mb-4">Rewards</h2>
            </div>
            <section>
                <div className="cards-wrapper">
                    <div className="step-reward completed active">
                        <div className="circle"></div>
                        <span className="reward-progress-count">0</span>
                        {profile.credits && profile.credits < 500 && (
                            <img src={arrowImg} style={{top: rewardsProgressBar(getRewardsNum(0, 'init'))}} className="award-arrow-icon"/>
                        )}
                    </div>
                    <div className="slider">
                        <p className="empty-progress">
                            Collect points to redeem instantly
                        </p>
                    </div>
                </div>
            </section>
            {loading ? (
                <Loader/>
            ) : (
                rewards.length > 0 && rewards.map((reward, index) => (
                    <section key={index}>
                        <div className="cards-wrapper">
                            <div className="step-reward completed active">
                                <div className="circle"></div>
                                <span className="reward-progress-count">{getRewardsNum(index)}</span>
                                {((profile.credits) && (profile.credits >= getRewardsNum(index)) && (profile.credits < getRewardsNum(index+1))) ? (
                                    <img src={arrowImg} style={{top: rewardsProgressBar(getRewardsNum(index))}} className="award-arrow-icon" />
                                ) : (
                                    ''
                                )}
                            </div>
                            <Slider key={`slider-${index}`} {...settings}
                                    className="reward-slider slider arrow-light slider-gap sliderz">
                                {reward && reward.map((rewardItems, itemIndex) => (
                                    <div key={itemIndex} className="cards-round">
                                        <img src={window.location.origin + rewardItems.thumbnail}
                                             alt="rewards-img"/>
                                        <div className="cards-info">
                                            <h6 className="reward-heading">{rewardItems.name}</h6>
                                            <p className="reward-sub-heading">{rewardItems.credits} required</p>
                                            <NavLink className="purchase-btn" to={`javaScript:void(0)`}  onClick={(event) => purchaseRewards(event, rewardItems.credits, rewardItems.name)}>
                                                Purchase
                                            </NavLink>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </section>
                ))
            )}

        </div>

        {/*Model*/}
        <div className="modal fade subscribe-modal" id="showWarnings" tabindex="-1"
             aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog subscribe-modal-dialog">
                <div className="modal-content subscribe-modal-content">
                    <div className="modal-body subscribe-modal-body">
                        <div className="subscribe-modal-body-back-img notification-back-img">
                            <img className="rewards-modal-icon" src={warningIcon} alt="warning-icon" />
                        </div>
                        <h6 className="subscribe-info-heading-modal">Warning..!!</h6>
                        <p className="subscribe-heading-modal"><div dangerouslySetInnerHTML={{ __html: warningMsg }} /></p>
                    </div>
                </div>
            </div>
        </div>
        <button style={{display: 'none'}} ref={showWarningModal} data-bs-toggle="modal" data-bs-target="#showWarnings">modal box</button>

        {/*Model*/}
        <div className="modal fade subscribe-modal" id="showSuccess" tabIndex="-1"
             aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog subscribe-modal-dialog">
                <div className="modal-content subscribe-modal-content">
                    <div className="modal-body subscribe-modal-body">
                        <div className="subscribe-modal-body-back-img notification-back-img">
                            <img className="rewards-modal-icon" src={rewardsImg} alt="rewards-success" />
                        </div>
                        <h6 className="subscribe-info-heading-modal">Congratulations</h6>
                        <p className="subscribe-heading-modal">{successMsg}</p>
                    </div>
                </div>
            </div>
        </div>
        <button style={{display: 'none'}} ref={showSuccessModal} data-bs-toggle="modal" data-bs-target="#showSuccess">modal box</button>

        {/*Rewards email modal*/}

                <div className="modal fade subscribe-modal" id="rewardsFormModal" tabIndex="-1"
                     aria-labelledby="exampleModalLabel" aria-hidden="true">
                    {loadingModal ? (
                        <Loader/>
                    ) : (
                    <div className="modal-dialog">
                        <div className="modal-content subscribe-modal-content">
                            <div className="modal-body subscribe-modal-body">
                                <h2 className="bio m-0">Email Address</h2>
                                <input
                                    type="text"
                                    value={rewardsEmail}
                                    placeholder="Enter Email"
                                    className="bio-detail-textarea"
                                    onChange={handleChangeRewardsEmail}
                                    ref={rewardsEmailRef}
                                />
                                {!isValidEmail && (<p className="text-red mt-1">Please enter valid email address</p>)}
                                    <a href="javaScript:void(0)" className="subscribe-btn-modal" onClick={rewardsModalForm} >Submit</a>
                            </div>
                        </div>
                    </div>
                    )}
                </div>

        <button style={{display: 'none'}} ref={showRewardsFormModal} data-bs-toggle="modal" data-bs-target="#rewardsFormModal">Rewards form box</button>
        </>
    );
}

export default TournamentPage;